const ms_MY = {
    homepage_title: 'Muat turun CalendarTask versi mudah alih dengan kod QR',
    homepage_slogn: 'CalendarTask versi mudah alih',
    homepage_ios_download: 'App Store dalam semakan...',
    homepage_download: 'Muat turun',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Muat turun CalendarTask versi mudah alih dengan kod QR',
    phonedownload_slogan: 'Segerak dengan PC & tablet, catat di mana-mana',
    phonedownload_send_vip: 'Pasang aplikasi dan dapatkan keahlian VIP',
    phonedownload_screenshot: 'Tangkapan skrin',
    phodedownload_macos: 'CalendarTask versi macOS',
    phodedownload_windows: 'CalendarTask versi Windows',
    phodedownload_otherbutton: 'Lihat sekarang',
    phodedownload_about: 'Hubungi kami',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Tanpa iklan',
    feature_easy: 'Paparan bulanan, mudah dan ringkas',
    feature_reminder: 'Peringatan tersuai',
    feature_countdown: 'Hitung undur hari jadi',

    vip_task_succ: 'Berjaya. Muat turun app untuk aktifkan VIP',
    vip_task_error: 'Penerimaan gagal',

    group_slogn: 'Jemputan CalendarTask pasukan',

    tt_title: 'CalendarTask',
    tt_share_1: 'Dikongsi dengan anda',
    tt_share_2: 'Jadual waktu',
    tt_share_show_1: 'Imbas kod QR dengan app "CalendarTask", PC dan telefon akan paparkan',
    tt_share_show_2: 'jadual waktu',
    tt_share_scan_1: 'Imbas dengan',
    tt_share_scan_2: 'app "CalendarTask"',
    tt_share_succ: 'Penyegerakan berjaya',

    v2_copyright: 'Hubungi service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Hak cipta terpelihara.',
    v2_download_appstore: 'Muat turun di App Store',
    v2_download_googleplay: 'Tersedia di Google Play',

    v2_main_title: 'CalendarTask Mudah Alih',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mudah Alih',
    v2_main_description: 'Cari <span class="name">CalendarTask</span> di App Store atau Google Play',
    v2_download_ios: 'Muat turun iOS',
    v2_download_android: 'Muat turun Android',
    v2_download_harmonyos: 'Muat turun HarmonyOS',
    v2_sync_status: 'Penyegerakan selesai! 1 dimuat naik, 0 dimuat turun',
    v2_feature_title: 'Penyegerakan data pelbagai peranti',
    v2_feature_description: 'Segerak antara telefon, tablet dan PC'
};
export default ms_MY;
